import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import es from "./locales/es.json";
import en from "./locales/en.json";
import ca from "./locales/ca.json";
import gl from "./locales/gl.json";

const resources = {
  es: { translation: es },
  en: { translation: en },
  ca: { translation: ca },
  gl: { translation: gl }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "es", // Idioma fijo: español
    fallbackLng: "es",
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

export const languages = [
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "ca", name: "Català", flag: "🏴" },
  { code: "gl", name: "Galego", flag: "🏴" }
];
